import RestService from './RestService';

export default class Questions extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/questions`);
        } else super('/questions');
    }

    fetchPreview(entityId) {
        return this.get(`${this.baseUrl}/${entityId}`, {
            preview: true,
        });
    }

    companyEditorCreate(body) {
        return this.post(`${this.baseUrl}/editor`, body);
    }

    companyEditorUpdate(questionId, body) {
        return this.put(
            `${this.baseUrl}/editor/${encodeURIComponent(questionId)}`,
            body
        );
    }

    companyEditorSaveAs(questionId, body) {
        return this.post(
            `${this.baseUrl}/editor/${encodeURIComponent(questionId)}/save-as`,
            body
        );
    }
}
